import Api from "../../../util/Api";

export default function getInitState() {
    return {
        patientEvidenceHistoryDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        patientEvidenceHistoryRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showEvidence'
            }
        ],
        patientEvidenceHistoryActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        patientEvidenceHistorySearchFields: [
            {
                name: "originalId",
                label: "Lelet ID",
                formSize: 4,
                formVisible: true,
                formType: "number"
            },
            {
                name: "operation",
                label: "Művelet",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {id: 'INSERT', text: 'Létrehozás'},
                        {id: 'DELETE', text: 'Törlés'},
                        {id: 'UPDATE FROM', text: 'Módosítás (eredeti)'},
                        {id: 'UPDATE TO', text: 'Módosítás (új)'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedBy",
                label: "History készítője",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedFrom",
                label: "History készítésének dátuma (tól)",
                formSize: 4,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "histCreatedTo",
                label: "History készítésének dátuma (ig)",
                formSize: 4,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "clinicId",
                label: "Szakrendelés",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getClinicList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                formType: "text",
                formSize: 4,
                formVisible: true,
            },
        ],
        patientEvidenceHistoryHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                sort: false
            },
            {
                name: "originalId",
                label: "Lelet ID",
                visibility: true,
                sort: true,
            },
            {
                name: "operation",
                label: "Művelet",
                sort: true,
                slot_name: "operation_format",
                visibility: true,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {id: 'INSERT', text: 'Létrehozás'},
                        {id: 'DELETE', text: 'Törlés'},
                        {id: 'UPDATE FROM', text: 'Módosítás (eredeti)'},
                        {id: 'UPDATE TO', text: 'Módosítás (új)'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedBy",
                label: "History készítője",
                sort: true,
                visibility: true,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedOn",
                label: "History készítésének dátuma",
                slot_name: "hist_created_on_format",
                sort: true,
                visibility: true
            },
            {
                name: "clinicId",
                label: "Szakrendelés",
                sort: true,
                visibility: true,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getClinicList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "patient.name",
                label: "Páciens",
                visibility: true,
            },
            {
                name: "patient.prefixedId",
                label: "Technikai azonosító",
                visibility: true,
            },
            {
                name: "finalReport",
                label: "Záróvélemény",
                visibility: false,
            },
            {
                name: "clinic.text",
                label: "Szakrendelés",
                visibility: true,
            },
            {
                name: "isClosed",
                label: "Lezárt",
                visibility: true,
                slot_name: "isClosed_format"
            },
            {
                name: "isOccupationHealthEvidence",
                label: "FEÜ-s dokumentum",
                visibility: true,
                slot_name: "boolean_format"
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: true,
                slot_name: "created_on_format",
            },
            {
                name: "buttons",
                label: "Opciók"
            }
        ]
    }
}
